<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end;">
          <v-menu offset-y>
            <template v-slot:activator="{on,attrs}">
              <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              >
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{ showFilters ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'BRANCH_ADMIN'">
              <v-select
                :items="shopList"
                label="Choose Shop..."
                item-text="name"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                v-model="queryParams.shopId"
                @change="getCountersByShopId(queryParams.shopId)"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-select
                :items="cashTypeList"
                label="Cash Type"
                v-model="queryParams.cashType"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="counterList"
                label="Counter Name"
                item-text="name"
                item-value="id"
                v-model="queryParams.counterId"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="counterCashList"
            class="elevation-1"
            :loading="showListLoading"
            :rows-per-page-items="rowsPerPageItems"
            :total-items="totalRows"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.counter.name }}</td>
              <td>{{ props.item.shop.name }}</td>
              <td>{{ props.item.cashType }}</td>
              <td style="text-align:right">{{ props.item.amount | decFormat(6)}}</td>
              <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date }}</td>
              <td>{{ props.item.updatedBy }}</td>
              <td>{{ props.item.description }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { counterCashService } from "../../services/counter-cash-service";
import { counterService } from "../../services/counter-service";
import { shopService } from "../../services/shop-service";
import { commonService } from "../../services/common-service";

export default {
  name: "CounterCashList",

  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Counter Cash Management",
        disabled: true
      },
      {
        text: "General Reports",
        disabled: true
      },
      {
        text: "Counter Cashs",
        disabled: true
      }
    ],
    headers: [
      { text: "Action", sortable: false },
      { text: "Counter Name", value: "counterName" },
      { text: "Shop Name", value: "shopName" },
      { text: "Cash Type", value: "cashType" },
      { text: "Amount", value: "amount" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Description", value: "description" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 25,
      sortBy: "createdDate",
      totalItems: 0
    },
    counterCashList: [],
    totalRows: 0,
    counterList: [],
    shopList: [],
    cashTypeList: [
      { label: "ALL", value: "" },
      { label: "Float", value: "FLOAT" },
      { label: "Pick Up", value: "PICK_UP" }
    ],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      cashType: "",
      counterId: "",
      shopId: "",
      updateUserId: "",
    }
  }),
  watch: {
    pagination: {
      handler() {
        this.getCounterCashList();
      },
      deep: true
    }
  },
  computed: {
    isHideColumnName() {
      if (this.user.role.roleName == "ADMIN") {
        return this.headers.filter(header => header.text !== "Action");
      }
      return this.headers;
    }
  },
  created() {
    let user = JSON.parse(localStorage.getItem("user"));
    if (user.role.roleName != "ADMIN") {
      this.queryParams.shopId = user.shopId;
    }
    if (user.role.roleName == "SALE_MANAGER") {
      this.queryParams.updateUserId = user.id;
    }
    if (user.role.roleName == "ADMIN" || user.role.roleName == 'BRANCH_ADMIN') {
      this.getAllShop();
    }
    if (user.shopId) {
      this.getCountersByShopId(user.shopId);
    }

    this.onSearch();

    //for deep linking
    if (this.$route.query.cashType) {
      this.queryParams.cashType = this.$route.query.cashType;
    }
    if (this.$route.query.counterId) {
      this.queryParams.counterId = this.$route.query.counterId;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = user.shopId;
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.updateUserId) {
      this.queryParams.updateUserId = this.$route.query.updateUserId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    getAllShop() {
      shopService
        .getAllShop()
        .then(res => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getCountersByShopId(shopId) {
      counterService
        .getCountersByShopId(shopId)
        .then(res => {
          this.counterList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.counterList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },

    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "counter-cashs", query: this.queryParams });
      this.getCounterCashList();
    },
    getCounterCashList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      counterCashService
        .getCounterCashList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          console.log(res);
          if (res.data) {
            this.counterCashList = res.data.counterCashList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/counter-cash/new");
    },
    onEdit(counterCash) {
      // go to details page
      this.$router.push("/counter-cash/" + counterCash.id);
    }
  }
};
</script>

<style scoped>
</style>




